import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators,FormBuilder } from '@angular/forms';
import { AppSettings } from './../../../app.constant';
import { UserService } from './../../../shared/services/user.service';

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent implements OnInit {
  resetPassword:FormGroup;
  constructor(private FormBuilder:FormBuilder,private _userService:UserService) { }
  OldPassword:any=null;
  NewPassword:any=null;
  PK_UserID:any=null;
  users:any;
  errorMessage:any;
  ngOnInit() {
    this.resetPassword = this.FormBuilder.group({
      'OldPassword':['', Validators.required],
      'NewPassword':['', [Validators.required, Validators.maxLength(10)]],
    })

    this.getAllUser();
  }

  getAllUser() :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
      // this.post=JSON.stringify();
      // console.log(this.post);
       this._userService.getAllUsers(AppSettings.API_ENDPOINT+AppSettings.GetAllUsers).subscribe(
      data =>
         {
           this.users=data;
      },
      error => this.errorMessage = <any>error)
  }
}
